import { useState } from 'react';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import RequestUnitsModal from '../../pages/Settings/Subscription/RequestUnitsModal';

import { ReactComponent as WarningTriangleOrange } from '../../assets/images/warning-orange.svg';
import { ReactComponent as WarningTriangleRed } from '../../assets/images/warning.svg';

const tooltipText = {
  LOW_BALANCE: 'Balance is running low; consider requesting additional units',
  NO_BALANCE: 'No units available, Please go to Settings > Subscriptions to request more',
};

const DisplayBalance = ({ balance, companyId }) => {
  const [isUnitsModalOpen, setIsUnitsModalOpen] = useState(false);

  const noBalance = balance <= 0;
  const balanceLow = balance >= 1 && balance <= 10;
  const showRequestUnitsButton = noBalance || balanceLow;

  return (
    <>
      <RequestUnitsModal isOpen={isUnitsModalOpen} setIsOpen={setIsUnitsModalOpen} companyId={companyId} />
      <Box sx={{ position: 'relative' }}>
        <Box sx={{ display: 'flex', gap: '10px', alignItems: 'center', color: noBalance ? '#e61610' : '#000000' }}>
          {noBalance && (
            <>
              Read Only Mode <WarningTriangleRed width={20} />
            </>
          )}
          {balanceLow && <WarningTriangleOrange width={20} />}

          <Box>Current Balance: {balance}</Box>

          {showRequestUnitsButton && (
            <Box sx={{ display: 'flex', alignItems: 'center', color: '#000000' }}>
              <Tooltip title={balanceLow ? tooltipText.LOW_BALANCE : tooltipText.NO_BALANCE} arrow>
                <InfoOutlined />
              </Tooltip>
            </Box>
          )}
        </Box>

        {showRequestUnitsButton && (
          <Box sx={{ width: '100%', textAlign: 'right', position: 'absolute', marginTop: '-4px', right: '32px' }}>
            <Button
              sx={{ minHeight: 0, minWidth: 0, padding: 0, fontSize: '12px' }}
              onClick={() => setIsUnitsModalOpen(true)}
            >
              Request Additional Units
            </Button>
          </Box>
        )}
      </Box>
    </>
  );
};

export default DisplayBalance;
